import MediaFileType from '@/shared/constants/MediaFileType';
import MediaTargetType from '@/shared/constants/MediaTargetType';
import BaseModel from '@/shared/models/BaseModel';
import { Url } from '@/shared/models/common';
import { preloadImage } from '@/shared/utils/image';

export interface MediaFileId {__mediaFileId: number}
export interface ContentId {__fileId: number}

export default class MediaFile extends BaseModel<MediaFileId> {
  type: MediaFileType | null = null;
  contentId!: ContentId;
  isLocked = false;
  isWarranty = false;
  content: Url | null = null;
  medium: Url | null = null;
  thumbnail: Url | null = null;
  target: MediaTargetType | null = null;
  description: string | null = null;
  note = '';

  static withData(data: Partial<MediaFile>): MediaFile {
    return Object.assign(new MediaFile(), data);
  }

  updateWith(that: MediaFile): void {
    this.id = that.id;
    this.content = that.content;
    this.contentId = that.contentId;
    this.type = that.type;
    this.thumbnail = that.thumbnail;
    this.description = that.description;
    this.note = that.note;
  }

  /**
   * true if this MediaFile is a temporary placeholder while the actual content is still being created/loading/...
   */
  get placeholder(): boolean {
    return this.id === null && this.content === null;
  }

  async preloadThumbnail(): Promise<void> {
    if (this.thumbnail) await preloadImage(this.thumbnail);
  }
}
